import React from "react";
import NodePath from "../NodePath/NodePath";
import { REASON_INFO } from "@imminently/decisively-core";
import DetailTable from "../../common/DetailTable/DetailTable";

const RENDER_DATA = false;

export interface ReasonTooltipProps {
  reason?: {
    type?: string;
    data?: Record<string, unknown>;
  };
  tooltip?: React.ReactNode;
}

const renderReasonDataValue = (field: string, value: unknown) => {
  const isPathLike = typeof value === "string" && (
    field.toLowerCase().includes("path")
    || field === "from"
    || field === "to"
  );

  if (isPathLike) {
    return <NodePath node={{ path: value as string }} showDescription={false} />;
  }

  if (field.toLowerCase().includes("paths") && Array.isArray(value)) {
    return (
      <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
        {value.map((pathValue, index) => (
          typeof pathValue === "string"
            ? <NodePath key={index} node={{ path: pathValue }} showDescription={false} />
            : <span key={index}>{String(pathValue)}</span>
        ))}
      </div>
    );
  }

  if (value && typeof value === "object") {
    return <pre style={{ margin: 0, whiteSpace: "pre-wrap" }}>{JSON.stringify(value, null, 2)}</pre>;
  }

  return <span>{String(value)}</span>;
};

const ReasonTooltip = ({ reason, tooltip }: ReasonTooltipProps) => {
  const reasonInfo = reason?.type ? REASON_INFO[reason.type] : undefined;
  const reasonData = reason?.data && typeof reason.data === "object" ? reason.data : undefined;
  console.log(reason);
  const reasonDataEntries = reasonData ? Object.entries(reasonData) : [];

  if (!tooltip && !reasonInfo) return null;

  return (
    <>
      {tooltip ? <div>{tooltip}</div> : null}
      {reasonInfo ? (
        <div style={{ marginTop: tooltip ? 6 : 0 }}>
          <div>{reasonInfo.name}</div>
          <small>{reasonInfo.description}</small>
          {RENDER_DATA && reasonDataEntries.length > 0 ? (
            <DetailTable style={{ marginTop: 8 }}>
              {reasonDataEntries.map(([field, value]) => (
                <DetailTable.Item key={field}>
                  <DetailTable.Title>{field}</DetailTable.Title>
                  <DetailTable.Content>{renderReasonDataValue(field, value)}</DetailTable.Content>
                </DetailTable.Item>
              ))}
            </DetailTable>
          ) : null}
        </div>
      ) : null}
    </>
  );
};

export default ReasonTooltip;
